import React from 'react';
import { motion } from 'framer-motion';
import './WhySection.css';

const WhySection = () => {
  const features = [
    { icon: '🎨', title: 'Pure Creativity', description: 'Each piece is uniquely designed with artistic flair' },
    { icon: '💎', title: 'Premium Materials', description: 'Only the finest materials for lasting quality' },
    { icon: '✨', title: 'Intricate Detailing', description: 'Meticulous attention to every small detail' },
    { icon: '💝', title: 'Made with Love', description: 'Every creation carries a piece of our heart' }
  ];

  return (
    <section className="why-section" id="about">
      <div className="container">
        <div className="home-section-header">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Why Handmade Haven?
          </motion.h2>

          <motion.p
            className="section-description"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            style={{ margin: 0 }}
          >
            
           Handmade Haven is a passion-driven handcrafted resin art and gift brand in Ahmedabad, founded by Muskan Kazi. We specialize in premium customized resin art, personalized gifts, and handmade home décor designed to add elegance and creativity to your space.

            Every product is carefully handcrafted using high-quality materials, intricate detailing, and artistic precision. From unique resin trays and decorative pieces to customized gifts for special occasions, each creation is made with love and attention to detail.
          </motion.p>
        </div>

        <div className="why-features">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="why-feature"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.05, y: -10 }}
            >
              <div className="why-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;